import { useEffect, useState } from "react";

/**
 * Re-renders the calling component on a fixed interval so anything derived
 * from `Date.now()` (countdowns, "X seconds ago" pills) stays fresh without
 * each caller wiring its own setInterval.
 */
export function useNow(intervalMs: number = 30_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
